import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Container,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import config from '../../../config';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { fetchAddressSettings } from '../../actions/addressSettings';
import NavBar from '../../components/NavBar';
import Form from '../Projects/Form';
import { editRoutes } from './navigations';
import { fetchFinanceSources } from '../../actions/financeSources';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class Edit extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.object,
    }),
    token: PropTypes.string,
    id: PropTypes.string,
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    panelBankers: PropTypes.arrayOf(PropTypes.object),
    location: PropTypes.shape({
      hash: PropTypes.string,
      pathname: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    newFetch: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  constructor(props) {
    super(props);
    const menuIsTab = window.innerWidth <= 630;
    this.state = {
      menuIsTab,
      hasChanges: false,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
    store.dispatch(fetchFinanceSources());
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 630;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  async submit(validations, data) {
    const { store } = this.context;
    const { t } = this.props;
    const project = data;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message).filter((m, idx, arr) => arr.indexOf(m) === idx) }));
      return;
    }
    if (project.maOwnerCompanyBranchShortName === '' && project.maOwnerCompanyBranchID === 0) {
      store.dispatch(flashErrorMessage({
        header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }),
        message: t('Project\'s Business Unit Owner is required', { ns: TRANSLATION_FILES.translation }),
      }));
      return;
    }
    project.externalAutofillUrl = project.externalAutofillUrl.trim();
    if (project.autofillFromUrl && project.externalAutofillUrl.trim() === '') {
      project.autofillFromUrl = false;
    }
    let res;
    try {
      res = await this.form.getWrappedInstance().getWrappedInstance().submit(`/projects/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(project),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, () => {
        store.dispatch(push(`/projects/${this.props.id}/edit/${this.props.location.hash}`));
      });
    });
    if (!this.props.data.marketplaceIsPublish && res.marketplaceIsPublish) {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} is successfully launched to Marketplace', { name: res.name, ns: TRANSLATION_FILES.translation }),
      }));
    } else if (this.props.data.marketplaceIsPublish && !res.marketplaceIsPublish) {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} is successfully removed from Marketplace', { name: res.name, ns: TRANSLATION_FILES.translation }),
      }));
    } else if (!this.props.data.marketplaceBuyerIsPublish && res.marketplaceBuyerIsPublish) {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} is successfully launched to Showroom for Buyers', { name: res.name, ns: TRANSLATION_FILES.translation }),
      }));
    } else if (this.props.data.marketplaceBuyerIsPublish && !res.marketplaceBuyerIsPublish) {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} is successfully removed from Showroom for Buyers', { name: res.name, ns: TRANSLATION_FILES.translation }),
      }));
    } else {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{name}} successfully updated', { name: res.name, ns: TRANSLATION_FILES.translation }),
      }));
    }
  }
  handleSubmit = (event) => {
    this.form.getWrappedInstance().getWrappedInstance().handleCheckIfPublish(event);
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { auth, id, loading, location, t } = this.props;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(l => ({
      ...l,
      text: t(l.text, { ns: l.text === 'Edit' ? TRANSLATION_FILES.translation : TRANSLATION_FILES.screens }),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                disabled={loading}
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Save', { ns: TRANSLATION_FILES.translation })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges || this.props.loading}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, project) => {
            this.submit(validations, project);
          }}
          onChange={this.handleOnChange}
          project={this.props.data}
          panelBankers={this.props.panelBankers}
          loading={this.props.loading}
          auth={this.props.auth}
          token={this.props.token}
          newFetch={this.props.newFetch}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Edit.mapStateToProps)(Edit));



// WEBPACK FOOTER //
// ./src/containers/Project/Edit.jsx